"use client";

import React from "react";
import { ShieldCheck, UserCheck, FileText, HardHat, Flame, ClipboardCheck, Building2, Ruler, Briefcase, GraduationCap, ArrowRight, CircleCheck } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  id: "sicurezza-lavoro",
  title: "Sicurezza sul lavoro D.Lgs 81/08",
  icon: ShieldCheck,
  description: "Consulenza completa per l'adeguamento e il mantenimento della conformità normativa in materia di salute e sicurezza nei luoghi di lavoro.",
  activities: ["Assunzione incarico RSPP esterno", "Audit sicurezza e verifiche di conformità", "Gestione scadenziario sicurezza aziendale", "Implementazione Sistemi SGSL"]
}, {
  id: "rspp-esterno",
  title: "Incarichi RSPP esterno",
  icon: UserCheck,
  description: "Servizio di Responsabile del Servizio di Prevenzione e Protezione esterno con gestione continuativa della sicurezza aziendale.",
  activities: ["Assunzione incarico RSPP per aziende di ogni settore", "Supporto al Datore di Lavoro", "Gestione riunioni periodiche sicurezza", "Assistenza durante ispezioni ATS/INL"]
}, {
  id: "dvr",
  title: "Valutazione dei rischi DVR",
  icon: FileText,
  description: "Redazione e aggiornamento del Documento di Valutazione dei Rischi conforme al D.Lgs 81/08.",
  activities: ["Redazione DVR aziendale completo", "Valutazioni specifiche (rumore, vibrazioni, chimico, ecc.)", "Aggiornamento DVR per modifiche aziendali", "Elaborazione procedure di sicurezza"]
}, {
  id: "sicurezza-cantieri",
  title: "Sicurezza cantieri CSP/CSE",
  icon: HardHat,
  description: "Coordinamento della sicurezza nei cantieri temporanei o mobili in fase di progettazione ed esecuzione.",
  activities: ["Incarico CSP (fase progettazione)", "Incarico CSE (fase esecuzione)", "Redazione PSC e Fascicolo dell’Opera", "Verifica POS e coordinamento imprese"]
}, {
  id: "progettazione-antincendio",
  title: "Prevenzione incendi e pratiche VVF",
  icon: Flame,
  description: "Servizi di progettazione e gestione pratiche antincendio secondo normativa vigente.",
  activities: ["Progettazione antincendio (Codice e Minicodice)", "Presentazione SCIA antincendio", "Valutazioni rischio incendio", "Gestione rapporti con Vigili del Fuoco"]
}, {
  id: "formazione",
  title: "Formazione sicurezza sul lavoro",
  icon: GraduationCap,
  description: "Organizzazione e gestione corsi di formazione obbligatoria in materia di sicurezza sul lavoro.",
  activities: ["Formazione lavoratori (generale e specifica)", "Formazione dirigenti, preposti e RSPP", "Addestramento DPI III categoria", "Aggiornamenti obbligatori periodici"]
}, {
  id: "direzione-lavori",
  title: "Direzione lavori",
  icon: Briefcase,
  description: "Gestione tecnica ed economica del cantiere con controllo dell’esecuzione delle opere.",
  activities: ["Coordinamento imprese esecutrici", "Contabilità lavori e SAL", "Verifica conformità opere", "Assistenza al collaudo finale"]
}, {
  id: "progettazione-architettonica",
  title: "Progettazione architettonica",
  icon: Building2,
  description: "Sviluppo di progetti architettonici per nuove costruzioni e ristrutturazioni.",
  activities: ["Progettazione preliminare, definitiva ed esecutiva", "Studi di fattibilità tecnica", "Rendering e layout progettuali", "Ottimizzazione spazi e funzionalità"]
}, {
  id: "progettazione-strutturale",
  title: "Progettazione strutturale",
  icon: Ruler,
  description: "Progettazione e verifica strutturale secondo le normative tecniche vigenti.",
  activities: ["Calcolo strutture in cemento armato, acciaio e legno", "Verifiche sismiche e adeguamenti", "Relazioni tecniche e di calcolo", "Deposito pratiche strutturali"]
}, {
  id: "scia-antincendio",
  title: "Pratiche edilizie e catastali",
  icon: ClipboardCheck,
  description: "Gestione completa delle pratiche amministrative edilizie e aggiornamenti catastali.",
  activities: ["Presentazione CILA, SCIA, Permessi di Costruire", "Pratiche catastali DOCFA e variazioni", "Sanatorie edilizie", "Accesso agli atti e volture"]
}];
export default function INostriServizi() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="servizi" className="relative w-full bg-background py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:40px_40px] opacity-20" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-5xl">
        
        <div ref={headerRef} className={`mb-16 text-center transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight mb-4">
            Soluzioni Ingegneristiche <span className="text-primary">su Misura</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Esplora il nostro elenco completo di consulenze ingegneristiche e tecniche. 
            Approccio innovativo, competenza tecnica e soluzioni personalizzate per ogni settore.
          </p>
        </div>

        <div ref={contentRef} className={`transition-all duration-700 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="bg-card/40 backdrop-blur-md border border-border shadow-xl p-1 md:p-2">
            <Accordion type="single" collapsible className="w-full">
              {servicesData.map((service, index) => {
              const Icon = service.icon;
              return <AccordionItem key={service.id} value={service.id} data-index={index} className="border-b border-border last:border-0 bg-card/50 hover:bg-accent/5 transition-colors">
                    <AccordionTrigger className="px-4 md:px-6 py-5 hover:no-underline group">
                      <div className="flex items-center gap-4 text-left">
                        <div className="flex-shrink-0 w-12 h-12 bg-primary/10 text-primary flex items-center justify-center border border-primary/20 group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                          <Icon className="w-6 h-6" />
                        </div>
                        <span className="text-lg md:text-xl font-semibold text-foreground group-hover:text-primary transition-colors">
                          {service.title}
                        </span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="px-4 md:px-6 pb-6 pt-2">
                      <div className="pl-0 md:pl-16">
                        <p className="text-muted-foreground mb-6 text-base leading-relaxed">
                          {service.description}
                        </p>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                          {service.activities.map((activity, actIndex) => <div key={actIndex} data-index={actIndex} className="flex items-start gap-3">
                              <CircleCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                              <span className="text-sm md:text-base text-foreground/80">{activity}</span>
                            </div>)}
                        </div>

                        <div className="flex justify-start">
                          <Button asChild variant="default" className="rounded-none shadow-md group">
                            <Link to="#">
                              Richiedi Info
                              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                            </Link>
                          </Button>
                        </div>
                      </div>
                    </AccordionContent>
                  </AccordionItem>;
            })}
            </Accordion>
          </div>
        </div>

      </div>
    </section>;
}